import { ThirdPartyNotificationClient } from "./third_party_notification"

export class MonitoringClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/monitoring`;

    this.thirdPartyNotification = new ThirdPartyNotificationClient(this.httpClient, this.baseURL)
  }
}
